import asyncSessionLoader from "../../../../../../core/gd/data/async-session-loader";
import ApiProject from "../../../../../../core/gd/api/project";
import {ProjectSystemType} from "../../../../../../core/model2/project/types";

type APICallParams = {
    company?        : ID
    parentProject?  : ID
    name            : string
    url?            : string
    owner?          : string
    color?          : number
}

const debug = false
// const debug = 'quickAdd_createLink'

export default async function quickAdd_createLink(params: APICallParams, onProjectAdded?: callback) {
    /*// create project for Link
    const data = await gd.api.Project.newWorkfolder(params).promise()

    onProjectAdded && onProjectAdded()

    const project: ProjectSession = gd.session.projects.get(data.projectId)
    project.properties.url = params.url
    await gd.api.Project.setProperties(project.id, project.properties).promise()

    debug && console.log(debug, 'onSubmit project', project.settings)

    return project*/

    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Link
    /*const data = await ApiProject.newLink({
        parentProjectId : params.parentProject,
        name            : params.name,
        color           : params.color,
        url             : params.url,
    }).promise()*/

    const data = await ApiProject.newResource({
        parentProjectId : params.parentProject,
        name            : params.name,
        systemType      : ProjectSystemType.LINK,
        color           : params.color,
        properties      : {
            url: params.url
        },
    }).promise()

    return gd.session.projects.get(data.projectId)
}